/**
 * Messages liés aux publications
 */

module.exports = {

    status: {
        draft: 'Draft',
        planned: 'Planned',
        inProgress: 'In progress',
        paused: 'Paused',
        return: 'Agent return',
        returnWaiting: 'Return',
        validated: 'Validated',
        publicationWaiting: 'Scheduled publication',
        publicationCanceled: 'Canceled publication',
        published: 'Published',
        complaint: 'Complaint',
        completed: 'Completed',
        publishing: 'Publication in progress',
        aiSuggestion: 'AI suggestion',
        customizing: 'Customization',

        proposal: {
            accepted: 'Accepted',
            declined: 'Declined',
            waiting: 'Waiting',
            draft: 'Draft'
        },

        legend: {
            published: 'Post published',
            scheduled: 'Post scheduled',
            edited: 'Post currently edited',
            ideas: 'Post idea'
        }
    },

    type: {
        image: 'Image',
        carousel: 'Carousel',
        album: 'Album',
        video: 'Video'
    },

    origin: {
        fromAi: 'AI',
        fromHorseChestnut: 'Key date',
        fromOrder: 'Tailor-made',
        fromCustomization: 'Customized'
    },

    priorityStatus: {
        normal: 'Normal',
        urgent: 'Urgent'
    },

    // Gestion des tâches d'un agent
    running: {
        button: {
            process: {
                continue: {
                    label: 'Continue the task'
                },
                start: {
                    label: 'Start the task'
                }
            },
            customer: {
                details: {
                    altLabel: 'View the customer details of { name }.'
                }
            }
        },
        list: {
            empty: 'No realized task was found.',
            fields: {
                publicId: 'ID',
                title: 'Name',
                customer: 'Customer',
                estimationTime: 'Duration',
                elapsedTime: 'Time spent',
                networks: 'Networks',
                status: 'Status'
            },
            networks: {
                options: {
                    default: 'Filter by network'
                }
            },
            statuses: {
                options: {
                    default: 'Filter by status'
                }
            }
        },
        customer: {
            details: {
                modal: {
                    title: 'File { customerName }',
                    menu: {
                        informations: {
                            label: 'Essential information',
                        },
                        editorialLine: {
                            label: 'Graphic and editorial line'
                        },
                        notificationSettings: {
                            label: 'Notifications'
                        }
                    }
                },
                sections: {
                    informations: {
                        fields: {
                            lastName: 'Name',
                            firstName: 'First name',
                            email: 'E-mail adress',
                            phone: 'Phone number',
                            societyName: 'Society name',
                            activitySector: 'Activity sector',
                            activitySummary: 'Activity summary',
                            workforce: 'Number of employees',
                            activityType: 'Activity type',
                            siteUrl: 'Website'
                        }
                    },
                    editorialLine: {
                        fields: {
                            tone: 'General tone of the editorial line',
                            formality: 'Formal or informal adress?',
                            emoticonType: 'With or without emoticon?',
                            logo: 'Society logotype',
                            graphicalCharter: 'Graphic chart'
                        }
                    },
                    notificationSettings: {
                        description: 'When do customers want to be contacted by their CM about the creation of their publications?',
                        fields: {
                            dayName: 'Day of the week',
                            time: 'Schedule',
                            mediums: 'By { mediums }',
                            frequency: 'Frequency'
                        },
                        medium: {
                            email: 'E-mail',
                            sms: 'SMS',
                            notification: 'Mobile notification'
                        },
                        frequencies: {
                            weekly: 'Every week',
                            fourteenDays: 'Every two weeks',
                            twentyOneDays: 'Every three weeks',
                            monthly: 'Every month'
                        },
                    }
                }
            }
        },
        processing: {
            task: {
                loading: {
                    error: 'An error occured while loading the task.'
                }
            },
            menu: {
                informations: {
                    label: 'Infos'
                },
                graph: {
                    label: 'Graphics'
                },
                hook: {
                    label: 'Tagline',
                },
                history: {
                    label: 'History'
                }
            },
            briefing: {
                logo: {
                    with: 'With logo',
                    without: 'Without logo',
                    consult: {
                        altLabel: 'View the logo.',
                    },
                    download: {
                        altLabel: 'Download the logo.'
                    }
                },
                canvaUrl: 'Canva project',
                fromHorseChestnut: 'Evergreen',
                fields: {
                    type: 'Task type',
                    networks: 'Network | Network | Networks',
                    format: 'Format',
                    categories: 'Theme | Theme | Themes',
                    /***/
                    subject: 'Subject',
                    target: 'Target',
                    marketing: 'Marketing objective',
                    tone: 'Tone',
                    emoticonType: 'With or without emoticon',
                    keywords: 'Keyword | Keyword | Keywords'
                },
                informations: {
                    charter: {
                        logo: {
                            label: 'Logo',
                            without: 'Without logo'
                        },
                        charter: {
                            label: 'Graphic chart',
                            without: 'Without graphic chart'
                        }
                    },
                    details: {
                        product: {
                            fields: {
                                why: 'What problem does the product/service address?',
                                name: 'Name of the product / service',
                                profit: 'Profits of the produit / service'
                            }
                        },
                        actuality: {
                            fields: {
                                about: 'What\'s the news about?',
                                title: 'News title',
                                date: 'Date',
                                relation: 'Relation to the customer\'s activity'
                            }
                        },
                        event: {
                            fields: {
                                name: 'Name of the event',
                                location: 'Location',
                                date: 'Date',
                                description: 'Description',
                                speakers: 'Speakers'
                            }
                        },
                        recruitment: {
                            fields: {
                                name: 'Name of the position',
                                type: 'Type of the position',
                                missions: 'Missions',
                                profile: 'Profile required',
                                salary: 'Salary band',
                                location: 'Location',
                                date: 'When will it start',
                                email: 'E-mail contact for applications'
                            }
                        },
                        brand: {
                            fields: {
                                name: 'Name of the brand',
                                sector: 'Sector',
                                message: 'Message the customer wishes to send',
                                inHook: 'Would you like it to appear in the tagline?'
                            }
                        },
                        aiSubject: {
                            fields: {
                                subject: 'Subject'
                            }
                        },
                        other: {
                            fields: {
                                message: 'Message',
                            }
                        },
                        standard: {
                            fields: {
                                message: 'Message'
                            }
                        },
                        fields: {
                            publicationUrl: 'Redirect URl',
                            inHook: 'Figure'
                        }
                    }
                },
                graph: {
                    briefing: 'Graphic requirements',
                    text: 'Graphic idea',
                    files: 'Graphic element',
                    wishedVideo: 'Desired video model',
                    canva: {
                        title: 'Canva project',
                        button: {
                            label: 'View the Canva project'
                        }
                    }
                },
            },
            pause: {
                modal: {
                    title: 'Put in pause',
                    description: 'Would you like to pause the current task? Please tell your manager why you want to pause.',
                    form: {
                        error: 'An error occured while putting in pause a task.',
                        fields: {
                            reason: 'Reasons for pausing'
                        }
                    }
                }
            },
            countDown: {
                end: 'The time for completing the task has elapsed.'
            },
            history: {
                menu: {
                    customer: {
                        label: 'Customer history'
                    },
                    task: {
                        label: 'Publication history'
                    }
                },
                customer: {
                    loading: {
                        error: 'An error occured while loading a customer\'s history.'
                    },
                    empty: 'Customer\'s history is empty.'
                },
                task: {
                    loading: {
                        error: 'An error occured while loading a task\'s history.'
                    },
                    version: 'Version { version }',
                    empty: 'The task resolution history is empty.'
                },
                details: {
                    hook: {
                        title: 'Tagline'
                    },
                    visual: {
                        suggestedMedias: {
                            button: {
                                display: 'View files suggested by l\'AI',
                                hide: 'Hide files suggested by l\'AI'
                            }
                        }
                    }
                }
            },
            proposal: {
                form: {
                    error: 'An error occured while saving your proposal.',
                    fields: {
                        hook: 'Tagline',
                        agentComment: 'Comment { applicationName }',
                        visualGenericComment: 'Comments on the visual to be created'
                    },
                    addFile: {
                       button: {
                           label: 'Add a file'
                       }
                    },
                    customer: {
                        comment: {
                            label: 'Customer comments'
                        }
                    }
                }
            },
            hookSuggestions: {
                suggestion: {
                    title: 'GPT proposal { position }',
                    button: {
                        select: 'Use'
                    }
                }
            }
        }
    },

    // Gestion de la notation
    rating: {
        modal: {
            title: 'Nous sommes impatients de voir les résultats !',
            description: 'Bravo, votre publication est prête pour être diffusée le { date } sur { networks } !',
            ratingTitle: 'Votre avis',
            ratingDescription: 'Dites-nous ce que vous avez pensé du travail de votre Community Manager !'
        }
    },

    // Gestion d'un retour
    return: {
        preview: {
            date: 'Date',
            hook: 'Tagline'
        },
        modal: {
            title: '{ taskTitle } - Return'
        },
        form: {
            error: 'An error occurred while registering your return. Please check that you have filled in the form correctly.',
            fieldsets: {
                hook: 'Tagline',
                visual: 'Visual'
            },
            creditsRequired: '{ count } credits required | { count } credits required | { count } credits required',
            creditsAnchor: '<a href="{ url }" title="">Get credits</a>',
            hook: {
                fields: {
                    comment: {
                        withoutCredits: {
                            label: 'Describe your return requirements. Please note that you cannot be asked to rewrite the entire tagline.'
                        },
                        withCredits: {
                            label: 'You can request another return using your credits ({ credits } credits).'
                        }
                    }
                },
                buttons: {
                    selfModify: 'I make my own modifications',
                    requestReturn: 'I request a return',
                    reset: 'Reset the tagline'
                }
            },
            files: {
                menu: {
                    button: 'File { index }'
                },
                fields: {
                    genericComment: 'Tell us what visual you want to create',
                    agree: {
                        true: 'It\'s perfect',
                        false: 'I like it, but...'
                    },
                    comment: {
                        withoutCredits: {
                            label: 'Describe the returns you would like to receive. Please note that it is not possible to request a complete redesign of the visual.'
                        },
                        withCredits: {
                            label: 'You can request another return using your credits ({ credits } credits).'
                        }
                    }
                },
                descriptions: {
                    genericComment: 'Ask us to create a customised visual using your credits.'
                },
                upload: {
                    legal: 'By adding a new file, you declare that you have rights to it and that you will not hold { application } responsible in the event of a conflict.',
                    button: {
                        label: 'No file to download | Download the visual | Download the visuals'
                    }
                }
            },
            fields: {
                publicationDate: 'Planned release date',
                publishNow: 'Publish now',
                agentComment: 'Comment { applicationName }'
            },
            submit: {
                validate: {
                    label: 'Valide the return'
                }
            }
        }
    },

    targeting: {
        genders: {
            female: 'Female',
            male: 'Male'
        },
        location: {
            type: {
                digital: 'Remote',
                presence: 'In presence',
                hybrid: 'Hybrid'
            }
        }
    },

    graph: {
        type: {
            photo: 'Photo style',
            illustrated: 'Illustrated style',
            textual: 'Text style',
            agentChoice: 'I trust'
        }
    },

    marketingObjective: {
        visibility: 'Visibility',
        traffic: 'Traffic',
        engagement: 'Engagement'
    },

    types: {
        complete: {
            label: 'Visual + Tagline',
        },
        visual: {
            label: 'Visual'
        },
        hook: {
            label: 'Tagline'
        }
    },

    subject: {
        types: {
            product: 'Product / service',
            actuality: 'Actuality',
            event: 'Event',
            recruitment: 'Recruitement',
            brand: 'Brand',
            other: 'Other'
        },
    },

    brand: {
        sectors: {
            team: 'Team',
            value: 'Value',
            csr: 'CSR',
            international: 'International',
            employer: 'Employer brand',
            label: 'Label - certification',
            history: 'History',
            other: 'Other'
        }
    },


    // Rédaction d'une publication
    write: {
        loading: {
            taskConfiguration: {
                error: 'An error occurred while loading the configuration.'
            },
            taskConfigurationGroup: {
                error: 'An error occurred while loading the configuration.'
            },
            taskFormats: {
                error: 'An error occurred while loading the formats.'
            },
            publicationCategories: {
                error: 'An error occurred while loading the categories.'
            },
            globalConfiguration: {
                error: 'An error occurred while loading the configuration.'
            },
            draftTasks: {
                error: 'An error occurred while loading the drafts.'
            }
        },
        draft: {
            modal: {
                title: 'Draft | Draft | Drafts',
                description: 'No draft exists | A draft exists : | { count } drafts exist :',
                buttons: {
                    create: {
                        label: 'Create a new publication'
                    }
                },
                tasks: {
                    title: {
                        default: 'Draft { position }'
                    }
                }
            }
        },
        planned: {
            success: 'The task { taskTitle } has been successfully planified for { date } at { time }.'
        },
        error: 'An error occurred during the recording.',
        step: {
            idea: 'Idea',
            text: 'The text brief',
            graph: 'The graphic brief',
            informations: 'Information and deadlines'
        },
        deliveryProjection: {
            networks: {
                label: 'Network : | Network : | Networks :',
                empty: 'Select one'
            },
            delivery: {
                label: 'Delivery :',
                button: {
                    urgent: {
                        label: 'More quickly'
                    },
                    normal: {
                        label: 'Later'
                    }
                }
            },
            category: {
                label: 'Subject'
            },
            publicationSuggestion: {
                label: 'Suggestion'
            },
            videoSelected: {
                label: 'Video'
            }
        },
        idea: {
            introduction: {
                title: 'You have an idea?',
                description: 'Use our form to describe the post of your dreams, or take a look at our gallery of pot ideas for inspiration!',
                withIdea: {
                    label: 'Yes, I have an idea for the post.'
                },
                withoutIdea: {
                    label: 'Give me some inspiration!'
                }
            },
            publicationSuggestions: {
                title: 'You don\'t have any ideas?',
                description: 'Select a visual that inspires you and ask for modifications to adapt it to your needs/idea.',
                empty: 'There is no sujjestion matching your search.',
                loadingError: 'An error occurred while loading the suggestions.',
                filterForm: {
                    fields: {
                        thematic: 'Theme',
                        networks: 'Networkds',
                        format: 'Format',
                        marketingObjective: 'Objective',
                    },
                    currentFilters: {
                        label: 'Active filters'
                    }
                },
                item: {
                    details: {
                        button: {
                            label: 'More details'
                        },
                        modal: {
                            title: '{ title } - Overview',
                            select: {
                                error: 'An error occured while saving your choice.',
                                button: {
                                    label: 'Select this publication'
                                }
                            }
                        },
                        description: {
                            title: 'Details of the publication'
                        },
                        hook: {
                            title: 'Tagline'
                        }
                    }
                }
            },
            taskType: {
                title: 'Publication type',
                description: 'Choose a complete publication (visual/video + tagline) or just the creation of a visual or tagline.'
            },
            networks: {
                title: 'Choose your networks',
                description: 'Choose one or several networks as well as the page on which you want the post to be published.',
                enabled: {
                    error: 'An error occurred during the network activation { network }.'
                },
                disabled: {
                    error: 'An error occured during the network desactivation { network }.'
                },
                accounts: {
                    about: 'Sélectionner la ou les pages de diffusion :',
                    loading: {
                        error: 'Une erreur s\'est produite pendant le chargement de vos comptes { network }.'
                    }
                }
            },
            formats: {
                title: 'Format',
                description: 'Choose your post format. Depending on the format selected, the number of credits may vary from the initial request.',
                incompatible: 'Format not available on selected networks'
            },
            hookSetting: {
                title: 'Tagline',
                fields: {
                    common: 'A single tagline',
                    unique: 'One tagline per network'
                }
            }
        },
        about: {
            title: 'What do I want to talk about?',
            description: 'Choose the main theme of your topic. You can also create your own theme by clicking on the "button +".',
            forms: {
                details: {
                    fields: {
                        languages: 'Publication languages'
                    },
                    product: {
                        fields: {
                            why: 'What problem does the product/service address?',
                            name: 'Name of the product/service',
                            profit: 'Name two benefits of the product/service',
                            url: 'Redirect URL',
                            inHook: 'Would you like it to appear in the tagline?'
                        }
                    },
                    actuality: {
                        fields: {
                            about: 'What\'s the news about?',
                            title: 'News title',
                            date: 'Date',
                            relation: 'Specify the relation with your activity.',
                            url: 'Redirect URL',
                            inHook: 'Would you like it to appear in the tagline?'
                        }
                    },
                    recruitment: {
                        fields: {
                            name: 'Name of the position',
                            type: 'Type of the position',
                            missions: 'Missions',
                            profile: 'Profile required',
                            salary: 'Salary band',
                            location: 'Location',
                            date: 'From when?',
                            email: 'E-mail contact for applications',
                            url: 'Redirect URL',
                            inHook: 'Would you like it to appear in the tagline?'
                        }
                    },
                    event: {
                        fields: {
                            name: 'Name of the event',
                            location: {
                                digital: 'Link to participate in the event',
                                presence: 'Location of the event',
                                hybrid: 'Location of the event'
                            },
                            locationType: 'Type of the event',
                            date: 'Date',
                            time: 'Time',
                            timezone: 'Time zone',
                            description: 'Description',
                            speakers: 'Speakers',
                            url: 'Redirect URL',
                            inHook: 'Would you like it to appear in the tagline?'
                        },
                        location: {
                            description: {
                                digital: 'Indiquer l\'adresse où les utilisateurs peuvent se connecter pour participer à l\'événement.',
                                presence: 'Indiquer l\'adresse où se rendre pour participer à l\'événement.',
                                hybrid: 'Indiquer l\'adresse physique et numérique où se rendre pour participer à l\'événement.'
                            }
                        }
                    },
                    brand: {
                        fields: {
                            name: 'Name of the brand',
                            sector: 'Category',
                            sectorPrecision: 'Other sector',
                            message: 'Describe the message you wish to send',
                            url: 'Redirect URL',
                            inHook: 'Would you like it to appear in the tagline?'
                        }
                    },
                    other: {
                        fields: {
                            message: 'Tell us all about it',
                            url: 'Redirect URL',
                            inHook: 'Would you like it to appear in the tagline?'
                        }
                    },
                    standard: {
                        fields: {
                            taskTitle: 'Title of the publication',
                            message: 'General context (what do I want to talk about?)',
                            url: 'Redirect URL',
                        },
                        button: {
                            publicationUrl: {
                                test: {
                                    label: 'Test an adress'
                                }
                            }
                        }
                    }
                }
            },
            category: {
                error: 'An error occured during adding a category'
            }
        },
        targeting: {
            title: 'Targeting',
            description: 'Detail the characteristics of the people who will be reading your future publication.',
            form: {
                fields: {
                    description: 'Who is the content for?',
                    gender: 'Gender',
                    age: 'Age',
                    location: 'The impact of my words'
                },
                genders: {
                    undefined: 'All',
                    female: 'Female',
                    male: 'Male'
                },
                ages: {
                    none: 'No restriction'
                }
            }
        },
        marketingObjective: {
            title: 'Marketing Objectives',
            description: 'Select the objective closest to the expected result.',
            buttons: {
                visibility: {
                    description: 'I want to deliver information to my community'
                },
                traffic: {
                    description: 'I want to encourage my community to visit my website'
                },
                engagement: {
                    description: 'I want my community to interact: comments, likes, reposts, etc.'
                }
            }
        },
        tone: {
            title: 'Tone',
            description: 'For this publication, I\'m rather....',
            form: {
                fields: {
                    editorialLine: 'Publication tone',
                    emoticon: 'With or without emoticon?'
                }
            }
        },
        keywords: {
            title: 'Keywords',
            description: 'Indicate the keywords that best characterise your publication and that should appear in the tagline.',
            form: {
                fields: {
                    keyword: 'Enter keywords'
                },
                remaining: '0 remaining | 1 remaining | { count } remaining.'
            },
            keyword: {
                description: 'Press the ENTER key on your keyboard to add a keyword'
            }
        },
        graph: {
            type: {
                title: 'I wish',
                description: 'Give a graphic orientation of the type of visual you want for this publication.'
            },
            videoSuggestions: {
                title: 'I wish',
                description: 'Choose the video model of your choice by clicking on "More details" and then select the video.',
                loadingError: 'An error occurred while loading the suggestions.',
                selectError: 'An error has occurred during the recording of your choice.',
                suggestions: {
                    empty: 'None of the suggestions match your task parameters.',
                    credits: '{ credits } credits',
                    moreInformationsButton: {
                        label: 'More details'
                    },
                    selectVideoButton: {
                        label: 'Select this video'
                    }
                }
            },
            settings: {
                title: 'Should my logo appear on my publication?', /*'Charte graphique',*/
                /*settings: {
                    logo: {
                        title: 'Mon logo doit-il figurer sur ma publication ?'
                    },
                    charter: {
                        title: 'Ma charte graphique doit apparaître sur ma publication ?'
                    }
                },**/
                description: 'It is all in the title ;-)',
                charter: {
                    required: 'You have to complete your graphic chart to continue. You can do this by clicking on this button.',
                    button: {
                        label: 'Complete the graphic chart'
                    },
                    modal: {
                        title: 'Graphic chart'
                    }
                }
            },
            contents: {
                title: 'Graphic requirements ?',
                description: 'Help our graphic designer get as close as possible to the look you want.',
                form: {
                    fields: {
                        wishedVisualBriefing: 'Graphic requirements',
                        wishedVisualText: 'I would like a text on my visual.'
                    },
                    placeholders: {
                        wishedVisualBriefing: 'One dominant colour, illustrated form, typography'
                    }
                },
                suggestion: {
                    preview: {
                        title: 'Visual | Visual | Visuals'
                    }
                }
            },
            upload: {
                title: {
                    default: 'Items that must be included',
                    hook: 'Your visuals'
                },
                description: {
                    default: 'JI send the essential information that must appear on the visual (photo of the product, team, trade show, poster, event, etc.).',
                    hook: 'Do you have any visuals you\'d like to share with us?'
                },
                form: {
                    fields: {
                        legalAccepted: 'I have the rights to use these files.',
                    },
                    legalAccepted: {
                        description: 'By ticking this box, you declare that you have the rights to these files and not to hold { application } responsible in the event of a conflict.'
                    },
                    button: {
                        addFile: {
                            label: 'Add a file'
                        }
                    }
                }
            }
        },
        informations: {
            summary: {
                title: 'Summary',
                fields: {
                    taskType: 'Type:',
                    networks: 'Network: | Network: | Networks:',
                    format: 'Format:',
                    category: 'Theme:',
                    subject: 'Subject:',
                    objective: 'Objective:',
                    styleWished: 'Style:',
                    withLogo: 'Logo:',
                    withCharter: 'Graphic chart:',
                    remainingCredits: '(0 remaining) | ({ count } remaining) | ({ count } remaining)'
                }
            },
            delivery: {
                impossible: 'No delivery date was found.',
                form: {
                    title: 'Infos and details',
                    description: 'By default, we offer you a delivery time for your publication. Use the "Urgent" mode if you\'re in a hurry!',
                    fields: {
                        propositions: 'Proposed delivery time',
                        title: 'Name your publication',
                        wishedDate: 'Planned release date'
                    },
                    withoutCredits: 'Free'
                }
            }
        }
    },

    list: {
        loadingResourcesError: 'An error occurred during data loading.',
        month: {
            navigation: {
                lightMenu: {
                    title: 'Yous posts'
                }
            },
            loadError: 'An error occurred during data loading.',
            empty: {
                noIdea: 'No post ideas for { currentMonth } have been generated yet.',
                canGenerate: 'Click on “Generate new ideas”!',
                generating: 'The first post ideas will appear in a few moments. Please wait while the first post is generated.'
            },

            networks: {
                label: 'Filter:'
            },

            generate: {
                newIdeas: {
                    button: 'Generate new ideas'
                },
                convertSubjectInTaskIdea: {
                    button: 'Convert to post idea'
                },
                initialized: 'To see your posts appear, click on the "Validate my topics" button. Your first posts will appear here after validating the topics 🤗',
                button: {
                    label: 'Generate my schedule'
                },
                subscriptionRequired: {
                    message: 'You must be a subscriber to generate a new schedule.',
                    button: {
                        subscribe: {
                            label: 'I subscribe'
                        }
                    }
                }
            },
            completeGeneration: {
                button: {
                    label: 'Generate the rest of the schedule'
                }
            },
            validationSubjects: {
                ready: 'Your subjects are ready to be validated. Click on the "Validate my subjects" button.',
                button: {
                    label: 'Validate my subjects'
                }
            },
            searching: {
                placeholder: 'Search for...',
                date: 'Date'
            },
            suggestions: {
                item: {
                    title: 'Post { position }',
                    description: {
                        title: 'Description',
                        updateError: 'An error occurred while updating the description.'
                    },
                    date: '{ date } at { hour }:{ minute }',
                    fromHorseChestnut: 'Evegreen',
                    horseChestnutEvent: {
                        versions: {
                            navigation: {
                                title: 'There is no other version for this day. | There is another version for this day | There are another versions for this day'
                            }
                        }
                    },

                    tutorialTask: {
                        title: 'Post title'
                    },

                    header: {
                        fields: {
                            title: 'Post title'
                        },
                        validateButton: {
                            label: 'Schedule the post',
                            help: {
                                tooltip: 'Validate to schedule the post on your social networks',
                                close: {
                                    label: 'Got it, don\'t show this again'
                                }
                            }
                        },
                        aiSubject: {
                            source: 'Source'
                        }
                    },
                    regenerateAISuggestionButton: {
                        altLabel: 'Generate a new post (image + tagline)'
                    },
                    hook: {
                        title: 'Tagline',
                        alternativeHooks: {
                            title: 'Validated hook: Alternative { position }',
                            menu: {
                                item: {
                                    label: 'Alternative { position }'
                                }
                            }
                        },
                        regenerate: {
                            button: {
                                altTitle: 'Generate a new tagline'
                            },
                            modal: {
                                title: 'Generate a tagline with AI'
                            }
                        }
                    },
                    convertInReturn: {
                        button: {
                            label: 'Request a return'
                        }
                    },
                    medias: {
                        title: 'Visual',
                        description: 'Validate the visual of your choice',
                        preview: {
                            button: {
                                altLabel: 'Preview the visual { position }.'
                            },
                            modal: {
                                title: 'Preview the visual { position }'
                            }
                        },
                        valid: {
                            button: {
                                altLabel: 'Validate the visual'
                            }
                        },
                        uploadMediaForm: {
                            error: 'An error occurred during recording.',
                            errorTooLarge: 'Your file exceeds the maximum size of 50 MB.',
                            fields: {
                                file: 'Upload my visual/video'
                            },
                            legal: {
                                description: 'By adding a new file, you declare that you have rights to it and not to hold { application } responsible in the event of a conflict.'
                            }
                        },
                        regenerate: {
                            button: {
                                altTitle: 'Generate new images'
                            },
                            modal: {
                                title: 'Generate other images using AI'
                            }
                        },
                        remove: {
                            modal: {
                                message: 'Are you sure you want to delete this file?',
                                error: 'An error occured during the deletion of the file.'
                            }
                        },
                        generatedByIA: {
                            altLabel: 'AI generated image'
                        },
                        graphicalLineTemplate: {
                            slideshow: {
                                title: 'Graphic model',
                                template: {
                                    generating: 'The current generation may take a few seconds, the time to generate the images and texts.'
                                }
                            },
                            add: {
                                altLabel: 'Create an image.'
                            },
                            edit: {
                                altLabel: 'Edit image'
                            },
                            preview: {
                                toolbar: {
                                    openEditorButton: {
                                        label: 'Advanced Edition'
                                    }
                                }
                            }
                        },
                        select: {
                            title: 'Background image'
                        }
                    },
                    footer: {
                        informations: {
                            fields: {
                                format: 'Format',
                                status: 'Status',
                                subject: 'Subject',
                                marketingObjective: 'Objective',
                                networks: 'Network',
                                tone: 'Tone',
                                emoticonType: 'Emoticon',
                                keywords: 'Keywords'
                            }
                        },
                        buttons: {
                            editMarketingObjective: {
                                label: 'Edit a marketing objective'
                            },
                            addKeyword: {
                                label: 'Add a keyword'
                            }
                        }
                    }
                }
            },
            requestReturn: {
                button: {
                    label: 'Request a return'
                }
            },
            requestMediaReturn: {
                button: {
                    label: 'Request a visual'
                }
            },

            planningPresentation: {
                introduction: {
                    withTasks: 'Your first post is ready to use. Click "GO" to<br />Start your Tookano journey!',
                    withoutTasks: 'Your posts are currently being generated. This may take a few minutes.'
                },
                button: {
                    start: 'GO'
                },
                videoModal: {
                    button: {
                        close: {
                            label: 'Skip video'
                        }
                    }
                },
                detailModal: {
                    line1: 'Your first post has been created based on the information you provided.',
                    line2: 'You can also access your Editorial Line management interface to add or modify your settings (colors, preferences, style, etc...).',
                    button: {
                        close: {
                            label: 'I want to see what\'s next!'
                        }
                    }
                }
            }
        },
        table: {
            fields: {
                title: 'Object',
                agent: 'Agent',
                priorityStatus: 'Status',
                status: 'State',
                publicationDate: 'Publication date',
                networks: 'Networkds'
            }
        },
        item: {
            defaultTitle: 'Task without title',
            date: {
                planned: 'Estimated delivery date:',
                publicationWaiting: 'Scheduled for publication on',
                published: 'Published on'
            }
        },
        button: {
            periodicity: {
                weekly: {
                    label: 'W',
                    altLabel: 'Display the weekly view.'
                },
                monthly: {
                    label: 'M',
                    altLabel: 'Display the monthly view.'
                }
            },
            add: {
                label: 'Add a publication',
                altLabel: 'Add a publication.'
            },
            edit: {
                altLabel: 'Edit a task { task }.'
            },
            aiSettings: {
                label: 'AI parameters',
                altLabel: 'Edit the parameters for managing publication schedules.'
            },
            duplicate: {
                withTitle: 'Duplicate a task { task }.',
                withoutTitle: 'Duplicate this task.',
                label: 'Duplicate'
            },
            consultPublicationProposals: {
                altLabel: 'View the task\'s publication proposals { task }.'
            },
            return: {
                label: 'Return',
                altLabel: 'Return or validate a task { task }.'
            },
            mode: {
                month: {
                    label: 'List',
                    altLabel: 'View as a list.'
                },
                calendar: {
                    label: 'Calendar',
                    altLabel: 'View as a calendar.'
                }
            },
            returnToList: {
                label: 'Return to the list'
            },
            filters: {
                label: 'Filter'
            },
            startTutorial: {
                altLabel: 'Go to the tutorial'
            },
            changeOwnerVisibility: {
                isVisible: {
                    altLabel: 'Hide the post to the customer.',
                },
                isHide: {
                    altLabel: 'Show the publication to the customer.'
                }
            },
            aiWritingStyle: {
                altLabel: 'Edit writing style settings.'
            }
        },
        filters: {
            fields: {
                searching: 'Search for a publication',
                status: 'State',
                priorityStatus: 'Status',
                network: 'Network',
                publicationDate: 'Published on',
                ideas: 'Post ideas',
                edited: 'Currently edited',
                scheduled: 'Scheduled posts',
                subjectsIdeas: 'Monitoring',
                published: 'Published posts',
                pendingValidation: 'Checking'
            }
        }
    },

    // Gestion par un manager
    managing: {

        list: {
            fields: {
                publicId: 'ID',
                title: 'Name',
                customer: 'Customer',
                agent: 'Agent',
                estimatedTime: 'Estimated time',
                elapsedTime: 'Time spent',
                priorityStatus: 'Status',
                status: 'State',
                networks: 'Networks'
            },
            remaining: {
                title: 'Remaining tasks'
            },
            completed: {
                title: 'Task history'
            }
        },

        item: {
            transfert: {
                anotherAgentButton: {
                    altLabel: 'Transfer the task { task } to another agent.'
                },
                anotherAgentModal: {
                    title: 'Transfer the task { task } to another agent'
                }
            }
        }
    },

    comment: {
        postedAt: '{ date }',
        author: {
            default: '{ network } user',
        },
        validationRequested: {
            from: 'You asked { to } to validate the task.',
            to: 'A validation request has been requested to you.'
        },
        validationAccepted: {
            from: {
                yes: 'You validated the production.',
                no: 'You declined the production.'
            },
            to: {
                yes: '{ to } accepted the production.',
                no: '{ to } declined the production.'
            }
        }
    },

    // Boost, gestion d'une publicité
    advert: {
        boostButton: {
            facebook: {
                label: 'Boost your audience on Facebook or Instagram'
            }
        }
    },

    validation: {
        status: {
            waiting: 'Pending approval',
            declined: 'Pending changes',
            accepted: 'Approved',
            disabled: 'Disabled',
            completed: 'Completed',
            new: 'New feedback'
        },
        statusDateLabel: {
            read: 'Feedback read',
            sent: 'Feedback sent',
            new: 'New feedback'
        },
        button: {
            request: {
                label: 'Request post review'
            }
        },
        request: {
            modal: {
                title: 'Request post review',
                emptyRecipients: 'We could not determine a recipient for this request.'
            },
            form: {
                error: 'An error occurred while sending your request.',
                selectContact: 'Select the profile that will need to approve the publication.'
            }
        },
        requestSent: {
            modal: {
                message: 'Email sent!',
                button: {
                    close: {
                        label: 'Done'
                    }
                }
            }
        },
        waitingList: {
            button: {
                accept: {
                    label: 'Accept',
                    altLabel: 'Accept the validation request.',
                    error: 'An error occurred while accepting the request.',
                    success: 'Thank you for approving the post!'
                },
                decline: {
                    label: 'Decline',
                    altLabel: 'Decline the validation request.',
                    error: 'An error occurred while declining the request.'
                }
            },
            modal: {
                onAccept: {
                    message: 'Thank you for approving the post!',
                    button: {
                        close: {
                            label: 'Done'
                        }
                    }
                }
            }
        }
    }

};
